import React from 'react'
import styled from 'styled-components'
import { ChainId, INTEGRAL_TOKEN } from '../../../constants'
import { CurrencyValue } from '../../../model'
import { TimeReleaseClaimInfo } from '../../../providers/transactions/model'
import { Parameter, Parameters } from './Parameters'
import { SingleItem } from './SingleItem'

interface Props {
  now: Date
  submittedAt: number
  txInfo: TimeReleaseClaimInfo
  option1ClaimedAmount?: CurrencyValue
  option2ClaimedAmount?: CurrencyValue
}

export function SingleTimeReleaseClaimItem({
  now,
  submittedAt,
  txInfo,
  option1ClaimedAmount,
  option2ClaimedAmount,
}: Props) {
  const { option1, option2 } = txInfo
  const { symbol } = INTEGRAL_TOKEN[ChainId.Mainnet]

  const option1Params = getDisplayParams(option1, symbol, '3 Years', option1ClaimedAmount)
  const option2Params = getDisplayParams(option2, symbol, '6 Months', option2ClaimedAmount)

  return (
    <Container>
      <SingleItem description={`Vesting Claim ${symbol}`} now={now} submittedAt={submittedAt} symbol0={symbol} />
      <Parameters>
        <Parameter text={option1Params.text} value={option1Params.value} />
        <Parameter text={option2Params.text} value={option2Params.value} />
      </Parameters>
    </Container>
  )
}

function getDisplayParams(
  estimatedValue: string,
  symbol: string,
  optionName: string,
  optionClaimedAmount?: CurrencyValue
) {
  const label = `${optionName}`
  return optionClaimedAmount
    ? {
        text: label,
        value: optionClaimedAmount.formatWithSymbol(),
      }
    : {
        text: `Estimated ${label}`,
        value: `${estimatedValue} ${symbol}`,
      }
}

const Container = styled.div``
